const getParam = (key = '', search = '') => {
  return new URLSearchParams(search).get(key) || undefined
}

const getUtmParams = search => {
  const utmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term']

  const utmSeachParams = new URLSearchParams()

  utmParams.forEach(utmParam => {
    const param = getParam(utmParam, search)
    if (param) {
      utmSeachParams.set(utmParam, param)
    }
  })

  return utmSeachParams.toString()
}

export { getParam, getUtmParams }
